<svg *ngIf="icon === 'arrow-right-alt'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="m14 18-1.4-1.45L16.15 13H4v-2h12.15L12.6 7.45 14 6l6 6Z" />
</svg>
<svg *ngIf="icon === 'bookmark'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M7 17.95 12 15.8 17 17.95V5H7ZM5 21V3H19V21L12 18ZM7 5H17H12Z" />
</svg>
<svg *ngIf="icon === 'bookmark-add'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M5 21V3H13Q13 3.575 13 4Q13 4.425 13 5H7V17.95L12 15.8L17 17.95V11Q17.575 11 18 11Q18.425 11 19 11V21L12 18ZM7 5H13Q13 5 13 5Q13 5 13 5Q13 5 13 5Q13 5 13 5H12H7ZM17 9V7H15V5H17V3H19V5H21V7H19V9Z"
  />
</svg>
<svg *ngIf="icon === 'bookmark-added'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M17.825 9 15 6.175 16.4 4.75 17.825 6.175 21.35 2.625 22.775 4.05ZM5 21V3H13Q13 3.575 13 4Q13 4.425 13 5H7V17.95L12 15.8L17 17.95V11Q17.575 11 18 11Q18.425 11 19 11V21L12 18ZM7 5H13Q13 5 13 5Q13 5 13 5Q13 5 13 5Q13 5 13 5H12H7Z"
  />
</svg>
<svg *ngIf="icon === 'content-copy'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M7 18V2H20V18ZM9 16H18V4H9ZM3 22V6H5V20H16V22ZM9 16V4V16Z" />
</svg>
<svg *ngIf="icon === 'shopping-basket'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M4.025 21 0.675 9H6.75L11.15 2.45Q11.275 2.25 11.5 2.125Q11.725 2 11.975 2Q12.225 2 12.45 2.125Q12.675 2.25 12.8 2.45L17.2 9H23.325L19.975 21ZM9.175 9H14.8L11.975 4.8ZM5.5 19H18.5H5.5ZM12 17Q12.825 17 13.413 16.413Q14 15.825 14 15Q14 14.175 13.413 13.587Q12.825 13 12 13Q11.175 13 10.588 13.587Q10 14.175 10 15Q10 15.825 10.588 16.413Q11.175 17 12 17ZM5.5 19H18.5L20.7 11H3.3Z"
  />
</svg>
<svg *ngIf="icon === 'expand-more'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M12 15.375 6 9.375 7.4 7.975 12 12.575 16.6 7.975 18 9.375Z" />
</svg>
<svg *ngIf="icon === 'account-tree'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M15 21v-3h-4V8H9v3H2V3h7v3h6V3h7v8h-7V8h-2v8h2v-3h7v8ZM4 5v4Zm13 10v4Zm0-10v4Zm0 4h3V5h-3Zm0 10h3v-4h-3ZM4 9h3V5H4Z"
  />
</svg>
<svg *ngIf="icon === 'history'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M14.8 16.2 11 12.4V7h2v4.6l3.2 3.2ZM12 21q-3.45 0-6.012-2.288Q3.425 16.425 3.05 13H5.1q.35 2.6 2.312 4.3Q9.375 19 12 19q2.925 0 4.962-2.038Q19 14.925 19 12t-2.038-4.963Q14.925 5 12 5q-1.725 0-3.225.8T6.25 8H9v2H3V4h2v2.35q1.275-1.6 3.113-2.475Q9.95 3 12 3q1.875 0 3.513.712 1.637.713 2.85 1.925 1.212 1.213 1.925 2.85Q21 10.125 21 12t-.712 3.512q-.713 1.638-1.925 2.85-1.213 1.213-2.85 1.926Q13.875 21 12 21Z"
  />
</svg>
<svg *ngIf="icon === 'logout'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="m16 17-1.375-1.45 2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5ZM3 21V3h9v2H5v14h7v2Z" />
</svg>
<svg *ngIf="icon === 'person'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M12 12q-1.65 0-2.825-1.175Q8 9.65 8 8q0-1.65 1.175-2.825Q10.35 4 12 4q1.65 0 2.825 1.175Q16 6.35 16 8q0 1.65-1.175 2.825Q13.65 12 12 12Zm-8 8v-2.8q0-.85.438-1.563.437-.712 1.162-1.087 1.55-.775 3.15-1.163Q10.35 13 12 13t3.25.387q1.6.388 3.15 1.163.725.375 1.162 1.087Q20 16.35 20 17.2V20Zm2-2h12v-.8q0-.275-.137-.5-.138-.225-.363-.35-1.35-.675-2.725-1.013Q13.4 15 12 15t-2.775.337Q7.85 15.675 6.5 16.35q-.225.125-.362.35-.138.225-.138.5Zm6-8q.825 0 1.413-.588Q14 8.825 14 8t-.587-1.412Q12.825 6 12 6q-.825 0-1.412.588Q10 7.175 10 8t.588 1.412Q11.175 10 12 10Zm0-2Zm0 10Z"
  />
</svg>
<svg *ngIf="icon === 'edit'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M5 19h1.4l8.625-8.625-1.4-1.4L5 17.6ZM19.3 8.925l-4.25-4.2L17.875 1.9 22.1 6.125ZM3 21v-4.25l10.6-10.6 4.25 4.25L7.25 21ZM14.325 9.675l-.7-.7 1.4 1.4Z"
  />
</svg>
<svg *ngIf="icon === 'delete'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M5 21V6H4V4h5V3h6v1h5v2h-1v15Zm2-2h10V6H7Zm2-2h2V8H9Zm4 0h2V8h-2ZM7 6v13Z" />
</svg>
<svg *ngIf="icon === 'filter-alt'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M14 13v7h-4v-7L2.95 4h18.1Zm-2-.7L16.95 6h-9.9Zm0 0Z" />
</svg>
<svg *ngIf="icon === 'close'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6Z"
  />
</svg>
<svg *ngIf="icon === 'factory'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M2 22V9.975L9 7v2l5-2v3h8v12Zm2-2h16v-8h-8V9.95l-5 2V10l-3 1.325Zm7-2h2v-4h-2Zm-4 0h2v-4H7Zm8 0h2v-4h-2Zm7-8h-5l1-8h3ZM4 20h16Z"
  />
</svg>
<svg *ngIf="icon === 'share'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M18 22q-1.25 0-2.125-.875T15 19q0-.175.025-.363.025-.187.075-.337l-7.05-4.1q-.425.375-.95.587Q6.575 15 6 15q-1.25 0-2.125-.875T3 12q0-1.25.875-2.125T6 9q.575 0 1.1.212.525.213.95.588l7.05-4.1q-.05-.15-.075-.337Q15 5.175 15 5q0-1.25.875-2.125T18 2q1.25 0 2.125.875T21 5q0 1.25-.875 2.125T18 8q-.575 0-1.1-.213-.525-.212-.95-.587L8.9 11.3q.05.15.075.337Q9 11.825 9 12t-.025.362q-.025.188-.075.338l7.05 4.1q.425-.375.95-.588Q17.425 16 18 16q1.25 0 2.125.875T21 19q0 1.25-.875 2.125T18 22Zm0-16q.425 0 .712-.287Q19 5.425 19 5t-.288-.713Q18.425 4 18 4t-.712.287Q17 4.575 17 5t.288.713Q17.575 6 18 6ZM6 13q.425 0 .713-.288Q7 12.425 7 12t-.287-.713Q6.425 11 6 11t-.713.287Q5 11.575 5 12t.287.712Q5.575 13 6 13Zm12 7q.425 0 .712-.288Q19 19.425 19 19t-.288-.712Q18.425 18 18 18t-.712.288Q17 18.575 17 19t.288.712Q17.575 20 18 20Zm0-15ZM6 12Zm12 7Z"
  />
</svg>
<svg *ngIf="icon === 'done'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="m9.55 18-5.7-5.7 1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4Z" />
</svg>
<svg *ngIf="icon === 'swap-vert'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M8 13V5.825L5.425 8.4 4 7l5-5 5 5-1.425 1.4L10 5.825V13Zm7 9-5-5 1.425-1.4L14 18.175V11h2v7.175l2.575-2.575L20 17Z"
  />
</svg>
<svg *ngIf="icon === 'vertical-align-top'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M11 21V10.8l-2.6 2.6L7 12l5-5 5 5-1.4 1.4-2.6-2.6V21ZM4 5V3h16v2Z" />
</svg>
<svg
  *ngIf="icon === 'vertical-align-bottom'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="M4 21v-2h16v2Zm8-4-5-5 1.4-1.4 2.6 2.6V3h2v10.2l2.6-2.6L17 12Z" />
</svg>
<svg *ngIf="icon === 'error'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M12 17q.425 0 .713-.288Q13 16.425 13 16t-.287-.713Q12.425 15 12 15t-.712.287Q11 15.575 11 16t.288.712Q11.575 17 12 17Zm-1-4h2V7h-2Zm1 9q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4 8.65 4 6.325 6.325 4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"
  />
</svg>
<svg
  *ngIf="icon === 'keyboard-arrow-left'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6Z" />
</svg>
<svg
  *ngIf="icon === 'keyboard-arrow-right'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="M9.4 18 8 16.6l4.6-4.6L8 7.4 9.4 6l6 6Z" />
</svg>
<svg
  *ngIf="icon === 'keyboard-arrow-down'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="m12 15.4-6-6L7.4 8l4.6 4.6L16.6 8 18 9.4Z" />
</svg>
<svg
  *ngIf="icon === 'keyboard-double-arrow-left'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="m11 18-6-6 6-6 1.4 1.4L7.825 12l4.575 4.6Zm6.6 0-6-6 6-6L19 7.4 14.425 12 19 16.6Z" />
</svg>
<svg
  *ngIf="icon === 'keyboard-double-arrow-right'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  viewBox="0 0 24 24"
>
  <path fill="currentColor" d="M6.4 18 5 16.6 9.575 12 5 7.4 6.4 6l6 6Zm6.6 0-1.4-1.4 4.575-4.6L11.6 7.4 13 6l6 6Z" />
</svg>
<svg *ngIf="icon === 'warning'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="m1 18 9-15 9 15Zm2.646-1.5h12.708L10 5.917Zm6.354-1q.312 0 .531-.219.219-.219.219-.531 0-.312-.219-.531Q10.312 14 10 14q-.312 0-.531.219-.219.219-.219.531 0 .312.219.531.219.219.531.219ZM9.25 13h1.5V9h-1.5Zm.75-1.792Z"
  />
</svg>
<svg *ngIf="icon === 'person-add'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M18 14v-3h-3V9h3V6h2v3h3v2h-3v3Zm-9-2q-1.65 0-2.825-1.175Q5 9.65 5 8q0-1.65 1.175-2.825Q7.35 4 9 4q1.65 0 2.825 1.175Q13 6.35 13 8q0 1.65-1.175 2.825Q10.65 12 9 12Zm-8 8v-2.8q0-.85.438-1.563.437-.712 1.162-1.087 1.55-.775 3.15-1.163Q7.35 13 9 13t3.25.387q1.6.388 3.15 1.163.725.375 1.162 1.087Q17 16.35 17 17.2V20Zm2-2h12v-.8q0-.275-.137-.5-.138-.225-.363-.35-1.35-.675-2.725-1.013Q10.4 15 9 15t-2.775.337Q4.85 15.675 3.5 16.35q-.225.125-.362.35-.138.225-.138.5Zm6-8q.825 0 1.413-.588Q11 8.825 11 8t-.587-1.412Q9.825 6 9 6q-.825 0-1.412.588Q7 7.175 7 8t.588 1.412Q8.175 10 9 10Zm0-2Zm0 7Z"
  />
</svg>
<svg *ngIf="icon === 'add-location'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M11 14h2v-3h3V9h-3V6h-2v3H8v2h3Zm1 5.35q3.05-2.8 4.525-5.088Q18 11.975 18 10.2q0-2.725-1.738-4.463Q14.525 4 12 4 9.475 4 7.737 5.737 6 7.475 6 10.2q0 1.775 1.475 4.062Q8.95 16.55 12 19.35ZM12 22q-4.025-3.425-6.012-6.363Q4 12.7 4 10.2q0-3.75 2.413-5.975Q8.825 2 12 2t5.587 2.225Q20 6.45 20 10.2q0 2.5-1.987 5.437Q16.025 18.575 12 22Zm0-11.8Z"
  />
</svg>
<svg *ngIf="icon === 'view-in-ar'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="m12 20.175-7-4.05v-8.1l7-4.05 7 4.05v8.1Zm-1-2.925v-4.6l-4-2.3v4.6Zm2 0 4-2.3v-4.6l-4 2.3ZM1 6V1h5v2H3v3Zm5 17H1v-5h2v3h3Zm12 0v-2h3v-3h2v5Zm3-17V3h-3V1h5v5Zm-9 4.9 4-2.3-4-2.3-4 2.3Zm0 1.75Zm0-1.75Zm1 1.75Zm-2 0Z"
  />
</svg>
<svg *ngIf="icon === 'print'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M16 8V5H8v3H6V3h12v5ZM4 10h16H6Zm14 2.5q.425 0 .712-.288.288-.287.288-.712t-.288-.713Q18.425 10.5 18 10.5t-.712.287Q17 11.075 17 11.5t.288.712q.287.288.712.288ZM16 19v-4H8v4Zm2 2H6v-4H2v-6q0-1.275.875-2.137Q3.75 8 5 8h14q1.275 0 2.138.863Q22 9.725 22 11v6h-4Zm2-6v-4q0-.425-.288-.713Q19.425 10 19 10H5q-.425 0-.713.287Q4 10.575 4 11v4h2v-2h12v2Z"
  />
</svg>
<svg *ngIf="icon === 'add'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path fill="currentColor" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
</svg>
<svg *ngIf="icon === 'variables'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M17.5,19v-3h-3v-2h3v-3h2v3h3v2h-3v3H17.5z M1.5,16V6h18v3h-2V8h-14v6h9v2H1.5z M3.5,12V8v6V12z"
  />
</svg>
<svg *ngIf="icon === 'swap'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="m15.207 2.29l4 3.996a1 1 0 0 1 .084 1.32l-.083.094l-4 4.006a1 1 0 0 1-1.498-1.32l.083-.094L16.083 8H5.5a1 1 0 0 1-.993-.883L4.5 6.999a1 1 0 0 1 .883-.993l.117-.007h10.59l-2.296-2.293a1 1 0 0 1-.084-1.32l.083-.095a1 1 0 0 1 1.32-.084zl4 3.995zm4.284 14.592l.006.117a1 1 0 0 1-.883.993l-.117.007H7.914l2.294 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.084l-.094-.084l-4-3.996a1 1 0 0 1-.084-1.32l.083-.094l4-4.004a1 1 0 0 1 1.498 1.32l-.083.094l-2.29 2.293h10.58a1 1 0 0 1 .993.883l.006.117z"
  />
</svg>

<svg
  *ngIf="icon === 'trash'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
  stroke-width="2"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  />
</svg>
<svg
  *ngIf="icon === 'lock-closed'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="currentColor"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
  />
</svg>
<svg
  *ngIf="icon === 'lock-open'"
  xmlns="http://www.w3.org/2000/svg"
  class="w-full h-full"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  stroke="currentColor"
>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
  />
</svg>

<!-- social media -->
<svg *ngIf="icon === 'facebook'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M24,12.1c0-6.6-5.4-12-12-12S0,5.4,0,12.1c0,6,4.4,11,10.1,11.9v-8.4h-3v-3.5h3V9.4c0-3,1.8-4.7,4.5-4.7C16,4.8,17.3,5,17.3,5v3h-1.5c-1.5,0-2,0.9-2,1.9v2.3h3.3l-0.5,3.5h-2.8v8.4C19.6,23,24,18.1,24,12.1z"
  />
</svg>
<svg *ngIf="icon === 'google'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M23.6,10H12.3v4.5h6.5c-0.3,1.5-1.1,2.7-2.4,3.6c-1.1,0.7-2.5,1.2-4.1,1.2c-3.1,0-5.8-2.1-6.7-5c-0.2-0.7-0.4-1.5-0.4-2.3s0.1-1.6,0.4-2.3c0.9-2.9,3.6-5,6.7-5c1.8,0,3.3,0.6,4.6,1.8l3.4-3.4c-2.1-1.9-4.8-3.1-8-3.1C7.6,0,3.5,2.7,1.5,6.6C0.7,8.2,0.3,10.1,0.3,12s0.5,3.8,1.3,5.4c2,3.9,6,6.6,10.7,6.6c3.2,0,6-1.1,7.9-2.9c2.3-2.1,3.6-5.2,3.6-8.8C23.7,11.5,23.7,10.7,23.6,10z"
  />
</svg>
<svg *ngIf="icon === 'twitter'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 0 24 24">
  <path
    fill="currentColor"
    d="M21.5,7.1c0,0.2,0,0.4,0,0.6c0,6.5-5,14-14,14v0c-2.7,0-5.3-0.8-7.5-2.2c0.4,0,0.8,0.1,1.2,0.1c2.2,0,4.4-0.7,6.1-2.1c-2.1,0-4-1.4-4.6-3.4c0.7,0.1,1.5,0.1,2.2-0.1C2.6,13.5,1,11.5,1,9.2c0,0,0,0,0-0.1c0.7,0.4,1.5,0.6,2.2,0.6C1,8.3,0.4,5.4,1.7,3.1c2.5,3.1,6.2,4.9,10.1,5.1c-0.4-1.7,0.1-3.5,1.4-4.7c2-1.9,5.1-1.8,7,0.2c1.1-0.2,2.2-0.6,3.1-1.2c-0.4,1.1-1.1,2.1-2.2,2.7c1-0.1,1.9-0.4,2.8-0.8C23.3,5.5,22.5,6.4,21.5,7.1z"
  />
</svg>

<svg
  *ngIf="icon === 'copy'"
  class="w-full h-full py-0.5"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
  fill="currentColor"
>
  <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
  <path
    d="M224 0c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224zM64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64H64V224h64V160H64z"
  />
</svg>

<svg *ngIf="icon === 'chevron-left'" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
  <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
  <path
    d="M206.7 464.6l-183.1-191.1C18.22 267.1 16 261.1 16 256s2.219-11.97 6.688-16.59l183.1-191.1c9.152-9.594 24.34-9.906 33.9-.7187c9.625 9.125 9.938 24.37 .7187 33.91L73.24 256l168 175.4c9.219 9.5 8.906 24.78-.7187 33.91C231 474.5 215.8 474.2 206.7 464.6z"
  />
</svg>
<svg *ngIf="icon === 'chevron-right'" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
  <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
  <path
    d="M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"
  />
</svg>
<svg *ngIf="icon === 'refresh'" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path
    d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
  />
</svg>
<svg *ngIf="icon === 'magnifying-glass'" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <!--!Font Awesome Pro 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.-->
  <path
    d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"
  />
</svg>
